import Methods from '../Methods';
import ResponseMode, { ReturnTypeByMode } from '../ResponseMode';
import Transport, { ITransport } from '../Transports';
import { ensureResponseMode } from '@/utils/utils';
import ICreateNumericCounterValueRequest from '../Requests/ICreateNumericCounterValueRequest';
import INumericCounterValue from '../Models/INumericCounterValue';

const baseUri = '/api/v1/numeric-counter-values';

class NumericCounterValueService {
    private _transport: ITransport;

    constructor(transport: ITransport) {
        this._transport = transport;
    }
    public createAsync<T extends ResponseMode = 'status'>(
        request: ICreateNumericCounterValueRequest,
        responseMode: T = 'status' as T,
    ): Promise<ReturnTypeByMode<INumericCounterValue, T>> {
        return this._transport.invokeAsync<
            ICreateNumericCounterValueRequest,
            ReturnTypeByMode<INumericCounterValue, T>
        >(Methods.Post, `${baseUri}?_rm=${ensureResponseMode(responseMode)}`, request);
    }

    public bulkInsertAsync<T extends ResponseMode = 'status'>(
        request: ICreateNumericCounterValueRequest[],
        responseMode: T = 'status' as T,
    ): Promise<ReturnTypeByMode<INumericCounterValue[], T>> {
        return this._transport.invokeAsync<
            ICreateNumericCounterValueRequest[],
            ReturnTypeByMode<INumericCounterValue[], T>
        >(Methods.Post, `${baseUri}/bulk-insert?_rm=${ensureResponseMode(responseMode)}`, request);
    }
}

const service = Object.freeze(new NumericCounterValueService(Transport));
export default service;
